
/* injects from baggage-loader */

'use strict';

export default class AddCardController {

	constructor($log, $scope, $timeout, $document, stripe, Parse, Alerts) {
		'ngInject';

		this.$log = $log;
		this.$scope = $scope;
		this.$document = $document;
		this.$timeout = $timeout;
		this.stripe = stripe;
		this.Parse = Parse;
		this.Alerts = Alerts;

		this.savingCard = false;
		this.showControls = true;

		this.fields = [{
			label: 'Card number',
			key: 'number'
		}, {
			label: 'Card holder',
			key: 'name'
		}, {
			label: 'Expiration',
			key: 'expiry'
		}, {
			label: 'CVC',
			key: 'cvc'
		}]

	}

	$onInit() {
		// this.$log.log(this.cardData)
		this.cardData = this.cardData || {};
	}

	close() {
		this.$scope.$emit('accountSettings.closeAddCardForm');
		this.cardData = {};
	}

	formComplete() {
		for (let field of this.fields) {
			if (!this.cardData[field.key]) {
				return false;
			}
		}
		return true;
	}

	async save(formData) {

		let data = formData.$$controls.reduce((obj, value) => {
			if (typeof value === 'object' && value.hasOwnProperty('$modelValue')) {
				obj[value.$name] = value.$modelValue;
			}
			return obj;
		}, {});
		// this.$log.log(data);

		for (let field of this.fields) {
			if (!data[field.key]) {
				this.Alerts.setLocal({
					msg: `Missing required field "${field.label}"`,
					type: 'danger'
				});
				return false;
			}
		}

		// Clear local alerts
		this.Alerts.clearLocal();

		this.savingCard = true;

		try {

			// {
			// 	number: '4242424242424242',
			// 	exp_month: 12,
			// 	exp_year: 2020,
			// 	cvc: '123'
			// }

			// Generate a token from the card info
			let token = await this.stripe.card.createToken({
				number: data.number,
				exp_month: data.expiry.split('/')[0],
				exp_year: data.expiry.split('/')[1],
				cvc: data.cvc
			});
			// this.$log.log(token);

			// Link the card to the user
			let card = await this.Parse.Cloud.run('linkCard', {
				source: token.id
			});
			// this.$log.log(card);


			this.savingCard = false;

			// Send the account back to the payments page
			this.$scope.$emit('accountSettings.newCard', card);

			// Display local alert
			this.Alerts.setLocal({
				msg: 'Card linked successfully',
				type: 'success'
			});

			this.cardData = {};

		} catch (err) {
			this.$log.error(err);

			this.savingCard = false;

			// Display local alert
			this.Alerts.setLocal({
				type: 'danger',
				msg: err.message || err
			});

		}

	}

}



// WEBPACK FOOTER //
// ./src/app/components/add-card/add-card.controller.js